const getEnumValue = (enumObj, value, uppercase = false) => {
    if (!value) {
        return undefined;
    }
    let search = value;
    if (uppercase) {
        search = value.toUpperCase();
    }
    for (const key of Object.keys(enumObj)) {
        const enumValue = enumObj[key];
        const normalizedEnumValue = uppercase ? enumValue?.toUpperCase() : enumValue;
        if (normalizedEnumValue === search) {
            return enumValue;
        }
    }
    return undefined;
};
export default getEnumValue;
